import React, { Children } from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function WhatYouGet() {
  const items = ["El Manual Maestro 'Metabolismo Pro-Edad' (Digital)", 'Protocolo de Contraste Térmico de 60 segundos', 'Plan de Nutrición Inversa: El ciclo de 7 días para resetear la leptina', 'Guía de Suplementos Reales vs. Estafas de Marketing', 'Lista de Compras Pro-Edad: Los 5 alimentos termo-activadores'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 bg-gray-50" data-id="element-227">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-228">
        <FadeIn data-id="element-229">
          <h2 className="mb-12 text-3xl font-bold text-center text-gray-900 md:text-4xl" data-id="element-230">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="p-8 bg-white shadow-xl rounded-3xl border border-gray-100" data-id="element-231">
          <motion.ul variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-50px'
        }} className="space-y-6" data-id="element-232">
            {items.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-233">
                <div className="flex-shrink-0 mt-1 mr-4" data-id="element-234">
                  <div className="flex items-center justify-center w-6 h-6 bg-emerald-100 rounded-full" data-id="element-235">
                    <svg className="w-4 h-4 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-236">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-237" />
                    </svg>
                  </div>
                </div>
                <span className="text-lg font-medium text-gray-800 md:text-xl" data-id="element-238">
                  {item}
                </span>
              </motion.li>)}
          </motion.ul>
        </div>
      </div>
    </section>;
}